import { render, staticRenderFns } from "./AddPanelSetting.vue?vue&type=template&id=f120a100&scoped=true&"
import script from "./AddPanelSetting.vue?vue&type=script&lang=js&"
export * from "./AddPanelSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120a100",
  null
  
)

export default component.exports